<template>
    <div>
        <div class="panel-tag">
            {{__t("GLOVO_ATTACH_REST")}}
        </div>

        <div class="form-group mt-2">
            <label class="form-label">
                {{__t('GLOVO_PORTAL_OWN')}}
            </label>

            <div class="input-group flex-nowrap">
                <b-form-radio-group id="btn-radios-1" @change="changeOwn" v-model="has_own" button-variant="outline-primary"
                      :options="[
                              { text: __t('YES'), value: true },
                              { text:  __t('NO'), value: false }
                     ]"
                    name="radios-btn-default"
                    buttons
                ></b-form-radio-group>
            </div>
        </div>

        <div class="glovo_location_auth" v-if="has_own">
            <div class="form-group mt-2">
                <label class="form-label" for="glovo_username">
                    {{__t("GLOVO_USERNAME")}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                    </div>
                    <input id="glovo_username" type="text" class="form-control" v-model="glovo_username">
                </div>
            </div>

            <div class="form-group mt-2">
                <label class="form-label" for="glovo_password">
                    {{__t("GLOVO_PASSWORD")}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                    </div>
                    <input id="glovo_password" type="text" class="form-control" v-model="glovo_password">
                </div>
            </div>

        </div>



        <div class="form-group mt-4 pt-4">
            <b-overlay :show="is_load">
                <label class="form-label" for="glovo_location">
                    {{__t("GLOVO_REST")}}*
                </label>

                <div class="" v-if="ext_restaurants.length > 0">
                    <v-select v-model="active_rest"
                              class="imc_reasons"
                              label="address"
                              :filter="searchRest"
                              :options="this.ext_restaurants"
                    >
                        <template slot="no-options">
                            {{__t("CHOICE_REST")}}
                        </template>

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{option.id}} - {{ option.address }}
                                </div>
                                <div>
                                    <small>
                                        {{option.details}}
                                    </small>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </b-overlay>
        </div>

    </div>
</template>

<script>
import Fuse from 'fuse.js';
import vSelect from 'vue-select'
import Yes_no from "../../../../sys/radio/yes_no.vue";
import ext_otp_code from "../../external_glovo/ext_otp_code.vue";


export default {
    name: "glovo_portal",
    components : {
        ext_otp_code,
        Yes_no,
        vSelect
    },

    data() {
        return {
            auth_ext : [],
            ext_restaurants : [],
            is_load : false,
            has_own : false,
        }
    },

    props : {
        location : {
            type : Object
        }
    },

    created () {
        if(this.has_own_glovo_auth) {
            this.has_own = true;
            this.loadGlovoAuthList();
        }

        this.load_external_rest();
    },

    methods : {

        async loadGlovoAuthList() {
            this.auth_ext = [];
            await api.get('/internal/ext_auth/glovo').then(({data}) => {
                if (data.status === "operation_success") {
                    this.auth_ext = data.data;
                    this.load_external_rest();
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },






        async otp_auth() {
            _core.showloading();
            agr_api.get('/aggregators/glovo/' +this.glovo_auth.id +'/otp_auth').then(({data}) => {
                EventBus.$emit('glovo_otp');
                _core.hideloading();
            }).catch(({response}) => {
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        changeOwn (cur_val) {
            console.log(cur_val);
            this.glovo_password = '';
            this.glovo_username = '';

        },

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: ['title', 'id', 'details','address'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        async load_external_rest() {
            this.is_load = true;
            this.ext_restaurants = [];

            agr_api.get('/aggregators/locations/glovo/' + this.location.id + "/ext_restaurants").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.ext_restaurants = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
               // EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {

        has_own_glovo_auth () {
            try {
                if (this.glovo_auth != null) {
                    let id = this.glovo_auth.id;
                    return parseInt(id) > 0;
                }
            }
            catch (e) {

            }
            return false;
        },

        glovo_username : {
            get :function () {
                return this.glovo_auth.username;
            },
            set: function (val){
                this.glovo_auth.username = val;
            }
        },

        glovo_password : {
            get :function () {
                return this.glovo_auth.password;
            },

            set: function (val){
                this.glovo_auth.password = val;
            }
        },

        is_new_portal : {
            get :function () {
                return this.glovo_auth.is_new_portal;
            },

            set: function (val){
                this.glovo_auth.is_new_portal = val;
            }
        },

        glovo_auth () {
            if(this.location.hasOwnProperty("ext_auth")) {
                let ext_auth = this.location.ext_auth;

                if (ext_auth.hasOwnProperty('id')) {
                    return ext_auth;
                }
            }

            return {
                "username" : "",
                "password" : '',
                "id" : -1,
                "is_new_portal" : false,
            };
        },

        active_rest : {
            get :function () {
                let active = null;
                if(this.ext_restaurants.length > 0) {
                    if(this.location.hasOwnProperty("ext_id")) {
                        this.ext_restaurants.map(pay => {
                            if(parseInt(pay.id) === parseInt(this.location.ext_id)) {
                                active = pay;
                            }
                        })
                    }
                }
                return active;
            },
            set: function (val){
                if(val != null) {
                    if (this.location.hasOwnProperty("ext_id")) {
                        this.location.ext_id = val.id;
                    }
                }
                else {
                    this.location.ext_id = "";
                }
            },
        },
    }
}
</script>

<style scoped>

</style>
